import { isNil } from 'lodash'

const toArray = (files) => {
  if (isNil(files)) return []
  if (Array.isArray(files)) return files
  if (files instanceof FileList) return Array.from(files)
  if (files instanceof File) return [files]

  const someFiles = files?.filter((file) => file instanceof File)

  return someFiles
}

export default toArray
